<template>
    <div class="footer-content">
        <div class="content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                TEEPUENG COMPANY LIMITED
            </div>
            <div class="pico">
                <p>0105561159428</p>
                <p>Pico Finance：477/2562</p>
                <p>D-U-N-S Number：661551744</p>
            </div>
            <div class="btns">
                <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)">
                    {{ btn.name }}
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="address">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                587/1-2 อาคารเอ ชั้นที่ 3 ถนนพระราม 3 แขวงบางโพงพาง เขตยานนาวา กรุงเทพมหานคร 10120
            </div>
            <div class="address">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                +66 0970641651
            </div>
            <div class="address">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                publish@teepuengglobal.com
            </div>
        </div>
        <div class="c">
            © 2026 Hak Cipta Milik TEEPUENG COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const btns = [
    {
        name: "หน้าแรก",
        path: "/",
    },
    {
        name: "เกี่ยวกับเรา",
        path: "/service",
    },
    {
        name: "บริการ",
        path: "/about",
    },
    {
        name: "ติดต่อเรา",
        path: "/contact",
    },
];
const handleClick = (path) => {
    console.log("path", path);
    router.replace(path);
};
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 259px;
    background: #22252D;
    padding: 0 200px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding-top: 31px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: start;
        margin-bottom: 25px;

        .title {
            max-width: 293px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #D3D3D3;
            line-height: 15px;

            img {
                width: 44px;
                height: 44px;
                object-fit: contain;
                margin-right: 7px;
            }
        }

        .pico {
            font-weight: 500;
            font-size: 12px;
            color: #D3D3D3;
            line-height: 18px;

            p {
                margin-bottom: 10px;
            }
        }

        .btns {
            max-width: 425px;
            display: flex;
            justify-content: space-around;
            flex: 1;

            .btn {
                font-weight: bold;
                font-size: 14px;
                color: #D3D3D3;
                line-height: 14px;
                cursor: pointer;
            }
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 44px;

        .address {
            max-width: 302px;
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: #D3D3D3;
            line-height: 18px;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 11px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 12px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>